export const DISCIPLINARY_ACTIONS_STATUS = {
  CREATED: 'CREATED',
  APPROVED: 'APPROVED',
  PUBLISHED_TO_EMPLOYEE: 'PUBLISHED_TO_EMPLOYEE',
  ACKNOWLEDGED: 'ACKNOWLEDGED',
  DENIED: 'DENIED',
};

export const DISCIPLINARY_ACTIONS_STATUS_LABELS = {
  [DISCIPLINARY_ACTIONS_STATUS.CREATED]: 'Created',
  [DISCIPLINARY_ACTIONS_STATUS.APPROVED]: 'Approved',
  [DISCIPLINARY_ACTIONS_STATUS.PUBLISHED_TO_EMPLOYEE]: 'Published',
  [DISCIPLINARY_ACTIONS_STATUS.ACKNOWLEDGED]: 'Acknowledged',
  [DISCIPLINARY_ACTIONS_STATUS.DENIED]: 'Denied',
};

export const DISCIPLINARY_ACTIONS_STATUS_COLOR = {
  [DISCIPLINARY_ACTIONS_STATUS.CREATED]: 'grey',
  [DISCIPLINARY_ACTIONS_STATUS.APPROVED]: 'green',
  [DISCIPLINARY_ACTIONS_STATUS.DENIED]: 'red',
  [DISCIPLINARY_ACTIONS_STATUS.PUBLISHED_TO_EMPLOYEE]: 'darkYellow',
  [DISCIPLINARY_ACTIONS_STATUS.ACKNOWLEDGED]: 'green',
};

export const MY_DATA = { id: -13, name: 'My Data', type: 'MY_DATA' };
export const MY_TEAM = { id: -2, name: 'My Team', type: 'MY_TEAM' };
export const MY_ORGANIZATION = { id: -3, name: 'My Organization', type: 'MY_ORGANIZATION' };
export const MY_COMPANY = { id: -1, name: 'My Company', type: 'MY_COMPANY' };

export const DISCIPLINARY_ACTIONS_COLUMN_ORDER = [
  { colId: 'RAISED_FOR' },
  { colId: 'TYPE' },
  { colId: 'STATUS' },
  { colId: 'DESCRIPTION' },
  { colId: 'RAISED_BY' },
  { colId: 'REPORTED_TIME' },
  { colId: 'COMPANY' },
  { colId: 'LOCATION' },
];
